module.exports = __webpack_public_path__ + "img/credit-card.3c0717fd.svg";